import { createPortal } from 'react-dom';

interface Toast { id: number; kind: 'good' | 'bad' | 'info'; text: string }

export function Toasts({ toasts }: { toasts: Toast[] }): React.ReactElement {
  return createPortal(
    <div className="toasts">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.kind}`}>
          {t.text}
        </div>
      ))}
    </div>,
    document.body,
  );
}
